/** Shared utilities for credit basis options and descriptions. */

export interface CreditBasisOption {
  value: string;
  label: string;
}

/** Build select options from a ladder (sorted tier array) + the ot_inclusive sentinel. */
export function buildCreditBasisOptions(
  ladder: Array<{ code: string; name: string; multiplier: number }>,
): CreditBasisOption[] {
  return [
    ...ladder.map(t => ({ value: t.code, label: `${t.name} (${t.multiplier}x)` })),
    { value: 'ot_inclusive', label: 'Final Overtime Tier' },
  ];
}

/** Resolve a human-readable label for a credit basis code. */
export function getCreditBasisLabel(
  basis: string,
  ladder: Array<{ code: string; name: string; multiplier: number }>,
): string {
  if (basis === 'ot_inclusive') return 'Final Overtime Tier';
  const tier = ladder.find(t => t.code === basis);
  return tier ? `${tier.name} (${tier.multiplier}x)` : basis;
}

/** Get description text for the current credit basis selection. */
export function getCreditBasisDescription(basis: string, basisLabel: string): string {
  if (basis === 'ot_inclusive') {
    return 'Credit is valued at your highest rate at shift end — scales up if overtime applies.';
  }
  return `Credit is valued at ${basisLabel} — fixed regardless of overtime progression.`;
}
